import { useEffect, useMemo, useState } from 'react'
import GShell from './GShell.jsx'
import { Title, Card, Pill, Err, fmtDate } from './gui.jsx'
import { watchLostFound, createLostItem, markReturned, deleteLostItem } from '../../lib/lostFound.js'

export default function GLostFound() {
  const [raw, setRaw] = useState({})
  const [f, setF] = useState({ item: '', foundBy: '', date: '', notes: '', photo: '' })
  const [tab, setTab] = useState('open')
  const [err, setErr] = useState('')
  useEffect(() => { const off = watchLostFound(setRaw); return () => off() }, [])
  const rows = useMemo(() => Object.values(raw || {}).filter(Boolean).sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0)), [raw])
  const list = rows.filter((r) => tab === 'open' ? !r.returned : r.returned)
  const add = async () => { setErr(''); try { await createLostItem(f); setF({ item: '', foundBy: '', date: '', notes: '', photo: '' }) } catch (e) { setErr(e?.message || 'Failed') } }
  return (
    <GShell>
      <Title title="Lost & Found" subtitle="Log found items and returns." />
      <Card>
        <div className="grid sm:grid-cols-3 gap-2">
          <input className="input" placeholder="Item" value={f.item} onChange={(e) => setF((s) => ({ ...s, item: e.target.value }))} />
          <input className="input" placeholder="Found by" value={f.foundBy} onChange={(e) => setF((s) => ({ ...s, foundBy: e.target.value }))} />
          <input className="input" type="date" value={f.date} onChange={(e) => setF((s) => ({ ...s, date: e.target.value }))} />
        </div>
        <input className="input w-full mt-2" placeholder="Notes / where found" value={f.notes} onChange={(e) => setF((s) => ({ ...s, notes: e.target.value }))} />
        <input className="input w-full mt-2" placeholder="Photo URL (optional)" value={f.photo} onChange={(e) => setF((s) => ({ ...s, photo: e.target.value }))} />
        <button className="btn-primary text-sm mt-2" onClick={add} disabled={!f.item.trim()}>Log Item</button>
        <Err msg={err} />
      </Card>
      <div className="flex gap-2">
        {[['open', 'Unclaimed'], ['returned', 'Returned']].map(([k, l]) => <button key={k} onClick={() => setTab(k)} className="text-xs font-bold px-3 py-1.5 rounded-full" style={tab === k ? { background: 'var(--ge-primary)', color: '#fff' } : { background: 'rgba(0,0,0,0.05)', color: '#4B5563' }}>{l} {rows.filter((r) => k === 'open' ? !r.returned : r.returned).length}</button>)}
      </div>
      <section className="pb-4 grid md:grid-cols-2 gap-3">
        {list.length === 0 ? <p className="text-sm text-gray-500">Nothing here.</p> : list.map((r) => (
          <Card key={r.id}>
            <div className="flex items-start justify-between gap-2">
              <div><div className="font-extrabold" style={{ color: 'var(--ge-primary)' }}>{r.item}</div>
                <div className="text-xs text-gray-500">{fmtDate(r.date)}{r.foundBy ? ` · found by ${r.foundBy}` : ''}{r.returned ? ` · returned to ${r.returnedTo || '—'}` : ''}</div></div>
              {r.returned ? <Pill bg="rgba(var(--ge-primary-rgb),0.14)" fg="var(--ge-primary)">Returned</Pill> : <Pill>Unclaimed</Pill>}
            </div>
            {r.notes ? <p className="text-xs text-gray-600 mt-1">{r.notes}</p> : null}
            <div className="mt-2 flex gap-2 pt-2 border-t" style={{ borderColor: 'rgba(0,0,0,0.06)' }}>
              {!r.returned ? <button className="btn-primary text-xs" onClick={() => { const to = window.prompt('Returned to (name):'); if (to != null) markReturned(r.id, to) }}>Mark Returned</button> : null}
              <button className="btn-ghost text-xs ml-auto" style={{ color: '#B91C1C' }} onClick={async () => { if (window.confirm('Delete?')) await deleteLostItem(r.id) }}>Delete</button>
            </div>
          </Card>
        ))}
      </section>
    </GShell>
  )
}
